import PropTypes from 'prop-types'
import React, { Component, Fragment } from 'react'
import { localize } from 'helpers/translator'
import CSSModules from 'react-css-modules'
import ShareLinkBox from './share_link_box'

import styles from './share_link.scss'

class ShareLink extends Component {

	constructor(props) {
		super(props)
		this.state = {
			color: 'blue',
			text: localize('btn_copy_text'),
		}
	}

	shouldComponentUpdate(nextProps, nextState) {
		return nextProps.visibleTab !== this.props.visibleTab || nextState.color !== this.state.color
	}

	copyToClipboard = () => {
		this.input_element.focus()
		this.input_element.select()
		document.execCommand('copy')
	}

	clickHandler = () => {
		this.setState({text: localize('btn_copy_text_copied'), color: 'green'})
		this.copyToClipboard()
		this.props.onSelect()
	}

	handleShareEditableLink = () => {
		this.props.onSelect(true, this.props.shouldShowEditableUrl)
	}

	handleSharePreviewLink = () => {
		this.props.onSelect(false, this.props.shouldShowEditableUrl)
	}

	render() {
		const hasEditableUrl = this.props.shouldShowEditableUrl && !!this.props.payload.editable_url
		return (
			<Fragment>
				{this.props.payload.url &&
					<ShareLinkBox
						linkLabel={this.props.previewLinkLabel}
						shouldShowSeparator={hasEditableUrl}
						url={this.props.payload.url}
						onSelect={this.handleSharePreviewLink}
					/>
				}
				{hasEditableUrl &&
					<ShareLinkBox
						linkLabel={this.props.editableLinkLabel}
						shouldShowSeparator={false}
						url={this.props.payload.editable_url}
						onSelect={this.handleShareEditableLink}
					/>
				}
			</Fragment>
		)
	}

}

ShareLink.defaultProps = {
	onSelect: () => {},
	shouldShowEditableUrl: false,
	previewLinkLabel: '',
	editableLinkLabel: '',
}

ShareLink.propTypes = {
	visibleTab: PropTypes.bool,
	payload: PropTypes.shape({
		url: PropTypes.string,
		// this attribute comes from backend
		// eslint-disable-next-line camelcase
		editable_url: PropTypes.string,
	}).isRequired,
	onSelect: PropTypes.func,
	shouldShowEditableUrl: PropTypes.bool,
	previewLinkLabel: PropTypes.string,
	editableLinkLabel: PropTypes.string,
}

export default (CSSModules(ShareLink, styles, {allowMultiple: true}))
